// src/components/ConsolesBoard.jsx
import React from "react";
import ConsoleCard from "./ConsoleCard";
import { motion } from "framer-motion";

const ConsolesBoard = ({ consoles, setConsoles, isOffline, onSessionEnded }) => {
  return (
    <div className="min-h-screen w-full overflow-y-auto py-6 px-4" style={{ backgroundColor: "#0F0F0F" }}>
      <div
        className="grid gap-6 mx-auto"
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
          gridTemplateRows: "repeat(2, auto)",
          maxWidth: "1600px",
        }}
      >
        {consoles.map((console, index) => (
          <motion.div
            key={console.id}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.2 }}
          >
            <ConsoleCard
              consoleData={console}
              setConsoles={setConsoles}
              isOffline={isOffline}
              index={index}
              onSessionEnded={onSessionEnded} // ✅ on passe la fonction ici
            />
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default ConsolesBoard;
